import { c as _c } from "react/compiler-runtime";
type CommonBorderedRadioButtonProps<T extends string> = {
  readonly type: T;
  readonly selected: T;
  readonly disabled?: boolean;
  readonly onChange: (type: T) => void;
} & ({
  readonly label: string;
  readonly children?: never;
} | {
  readonly label?: never;
  readonly children: React.ReactNode;
});
export default function CommonBorderedRadioButton(t0) {
  const $ = _c(22);
  const {
    type,
    selected,
    label,
    disabled: t1,
    onChange,
    children
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const isSelected = selected === type;
  const wrapperClasses = isSelected ? "tw-ring-primary-400 tw-bg-[#202B45] tw-shadow-xl" : `tw-ring-iron-700 tw-bg-iron-800 tw-shadow ${disabled ? "" : "hover:tw-ring-iron-650"}`;
  const inputClasses = isSelected ? "tw-text-primary-500 focus:tw-ring-primary-500" : "tw-text-primary-400 focus:tw-ring-primary-400";
  const labelClasses = isSelected ? "tw-text-primary-400" : `tw-text-iron-300 ${disabled ? "" : "group-hover:tw-text-iron-200"}`;
  let t2;
  if ($[0] !== disabled || $[1] !== onChange || $[2] !== type) {
    t2 = () => {
      if (!disabled) {
        onChange(type);
      }
    };
    $[0] = disabled;
    $[1] = onChange;
    $[2] = type;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onSelectedChange = t2;
  const t3 = `${wrapperClasses} tw-flex-1 tw-group tw-relative tw-rounded-lg tw-ring-1 tw-ring-inset tw-px-4 tw-py-4 focus:tw-outline-none tw-flex tw-items-center tw-gap-x-3 tw-transition tw-duration-300 tw-ease-out ${disabled ? "tw-opacity-50 tw-cursor-not-allowed" : "tw-cursor-pointer"}`;
  const t4 = `${inputClasses} tw-form-radio tw-h-4 tw-w-4 sm:tw-h-5 sm:tw-w-5 tw-bg-iron-800 tw-border-iron-650 tw-border tw-border-solid focus:tw-ring-2 tw-ring-offset-iron-800 tw-cursor-pointer tw-transition tw-duration-300 tw-ease-out`;
  let t5;
  if ($[4] !== disabled || $[5] !== isSelected || $[6] !== onSelectedChange || $[7] !== t4 || $[8] !== type) {
    t5 = <input id={type} type="radio" disabled={disabled} checked={isSelected} onChange={onSelectedChange} className={t4} />;
    $[4] = disabled;
    $[5] = isSelected;
    $[6] = onSelectedChange;
    $[7] = t4;
    $[8] = type;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== children || $[11] !== disabled || $[12] !== label || $[13] !== labelClasses) {
    t6 = label ? <span className={`${labelClasses} ${disabled ? "tw-text-iron-600" : ""}`}>{label}</span> : children;
    $[10] = children;
    $[11] = disabled;
    $[12] = label;
    $[13] = labelClasses;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <div className="tw-flex tw-items-center tw-whitespace-nowrap tw-truncate tw-transition tw-duration-300 tw-ease-out"><div className="tw-flex tw-flex-col tw-text-base tw-font-semibold tw-truncate tw-transition tw-duration-300 tw-ease-out">{t6}</div></div>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== onSelectedChange || $[18] !== t3 || $[19] !== t5 || $[20] !== t7) {
    t8 = <div onClick={onSelectedChange} className={t3}>{t5}{t7}</div>;
    $[17] = onSelectedChange;
    $[18] = t3;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}